import { useEffect, useState } from "react";

let activeToolbarId: string | null = null;
const listeners = new Set<(id: string | null) => void>();

export const useToolbarVisibility = (toolbarId: string) => {
    const [isActive, setIsActive] = useState(activeToolbarId === toolbarId);

    useEffect(() => {
        const listener = (id: string | null) => {
            setIsActive(id === toolbarId);
        };

        listeners.add(listener);
        return () => {
            listeners.delete(listener);
        };
    }, [toolbarId]);

    const setActive = (active: boolean) => {
        if (active) {
            activeToolbarId = toolbarId;
            listeners.forEach((fn) => fn(toolbarId));
        } else if (activeToolbarId === toolbarId) {
            activeToolbarId = null;
            listeners.forEach((fn) => fn(null));
        }
    };

    return [isActive, setActive] as const;
};
